/** A single description for roles on the group level. */

/**
 * Object that determines all different permission rules for users to get
 * access on the group level.
 */

/** Names for all permissions or roles within the group level. */
export let RequiredRoleGroupLevelName = /*#__PURE__*/function (RequiredRoleGroupLevelName) {
  /** Whether the user can edit group details like name or imageUrl */
  RequiredRoleGroupLevelName["canEditGroupDetails"] = "canEditGroupDetails";
  /** Whether the user can invite a member in a group */
  RequiredRoleGroupLevelName["canInviteUsersToGroup"] = "canInviteUsersToGroup";
  /** Whether the user can resend an invitation to a group */
  RequiredRoleGroupLevelName["canResendInvitationToGroup"] = "canResendInvitationToGroup";
  /** Whether the user has permission to edit member */
  RequiredRoleGroupLevelName["canEditMember"] = "canEditMember";
  /** Whether the user has permission to delete members from group */
  RequiredRoleGroupLevelName["canDeleteMemberFromGroup"] = "canDeleteMemberFromGroup";
  return RequiredRoleGroupLevelName;
}({});